module.exports = __webpack_public_path__ + "cd455783/img/grid-web-icon.d0395d64.svg";